import request from '@/util/request'

// 登录
export function loginByPhone(PhoneNumber, PassWord) {
  const data = {
    PhoneNumber,
    PassWord
  }
  return request({
    url: 'api/User/Login',
    method: 'post',
    data
  })
}

// 获取注册验证码
export function fetchSignUpCode(PhoneNumber) {
  return request({
    url: 'api/User/SendUserAuthCode',
    method: 'post',
    data: { PhoneNumber }
  })
}

// 注册
export function signUp(data) {
  return request({
    url: 'api/User/UserRegister',
    method: 'post',
    data
  })
}

// 获取忘记密码验证码
export function fetchForgetCode(PhoneNumber) {
  return request({
    url: 'api/User/SendChangePassWordAuthCode',
    method: 'post',
    data: { PhoneNumber }
  })
}

// 修改密码
export function changePassWord(data) {
  return request({
    url: 'api/User/ChangePassWord',
    method: 'post',
    data
  })
}

// 获取用户已购信息展示，仅第一页会返回用户相关信息
// pageIndex={pageIndex}&pageSize={pageSize}
// res:{
//   "Data": {
//     "UserShowInfo": {
//       "PhoneNumber": "sample string 1",
//       "WechatNickName": "sample string 2",
//       "Email": "sample string 3",
//       "Profession": "sample string 4",
//       "WorkSpace": "sample string 5"
//     },
//     "PurchaseShowModel": [
//       {
//         "ProductName": "sample string 1",
//         "PhoneNumber": "sample string 2",
//         "PayTime": "2019-02-15T14:58:26.8924635+08:00",
//         "ProductPrice": 4.0
//       }
//     ]
//   },
//   "Success": true,
//   "ErrorCode": "sample string 2",
//   "ErrorMessage": "sample string 3",
//   "ServiceTime": "sample string 4"
// }
export function getUserInfo(params) {
  return request({
    url: 'api/UserOperat/GetUserPurchaseInfoModel',
    method: 'post',
    params
  })
}

export function saveUserInfo(data) {
  return request({
    url: 'api/UserOperat/SaveUserInfo',
    method: 'post',
    data
  })
}
// 获取扫码登录的地址
// res: Data
export function getQrUrl(notifyUrl) {
  return request({
    url: 'api/User/GetQRConnectUrl',
    method: 'get',
    params:{notifyUrl}
  })
}

// 用户扫码登录,回调地址获取token
// URI Parameters: code={code}&state={state}
// res: Data: {
//   "Token": "sample string 1",
//   "UnionId": "sample string 2"
// },
export function scanLogin(params) {
  return request({
    url: 'api/User/ScanLogin',
    method: 'get',
    params
  })
}

// 扫码登陆后绑定手机号
// req:{
//   "UnionId": "sample string 1",
//   "PhoneNumber": "sample string 2",
//   "UserName": "sample string 3",
//   "AuthCode": "sample string 4",
//   "PassWord": "sample string 5"
// }
export function scanRegister(data) {
  return request({
    url: 'api/User/ScanRegister',
    method: 'post',
    data
  })
}

// 获取扫码绑定手机验证码
export function fetchScanCode(PhoneNumber) {
  return request({
    url: 'api/User/SendScanAuthCode',
    method: 'post',
    data: { PhoneNumber }
  })
}